import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchVehiclesList = () => apiActionCreator({
  'endpoint': '/part-number-code/vehicles',
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_VEHICLE_LIST_REQUEST,
    ActionTypes.FETCH_VEHICLE_LIST_SUCCESS,
    [
      ActionTypes.FETCH_VEHICLE_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
 
